import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Alert } from "react-bootstrap";
import logo from "./Images/logo-jcumas.png";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: email, password: password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("rol", data.rol);
        localStorage.setItem("id", data.id);
        setSuccess("Inicio de sesión correcto. Redirigiendo…");
        setTimeout(() => navigate("/home"), 600);
      } else {
        setError(data.message || "Usuario o contraseña incorrectos");
        setLoading(false);
      }
    } catch (err) {
      setError("Ocurrió un error al conectarse con el servidor");
      setLoading(false);
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#eef4fb" }}
    >
      <Row className="w-100 justify-content-center">
        <Col xs={11} sm={10} md={8} lg={6} xl={5}>
          <Card
            className="border-0"
            style={{
              borderRadius: "var(--sp-radius)",
              boxShadow: "0 8px 32px rgba(13,110,253,0.14)",
              overflow: "hidden",
            }}
          >
            {/* Cabecera blanca: fondo azul confundia con los tonos azules del logo */}
            <div
              style={{
                backgroundColor: "#ffffff",
                borderBottom: "1px solid var(--sp-border-strong)",
                padding: "28px 24px 22px",
                textAlign: "center",
              }}
            >
              <img
                src={logo}
                alt="Logo JCUMAS 060.013"
                className="img-fluid"
                style={{ maxWidth: "300px", height: "auto", objectFit: "initial" }}
              />
              <p
                style={{
                  color: "#0d6efd",
                  marginTop: "14px",
                  marginBottom: 0,
                  fontSize: "13px",
                  letterSpacing: "0.05em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                Oficina Virtual
              </p>
            </div>

            {/* Formulario */}
            <Card.Body className="p-4">
              {error && (
                <Alert variant="danger" className="mb-3 py-2 text-center small">
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {error}
                </Alert>
              )}

              {success && (
                <Alert variant="success" className="mb-3 py-2 text-center small">
                  <i className="bi bi-check-circle me-1"></i>
                  {success}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: 600, color: "#333", fontSize: "14px" }}>
                    Usuario
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Ingresa tu correo electrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      padding: "11px 14px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label style={{ fontWeight: 600, color: "#333", fontSize: "14px" }}>
                    Contraseña
                  </Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{
                      padding: "11px 14px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      fontSize: "14px",
                    }}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-100"
                  style={{
                    padding: "12px",
                    backgroundColor: "#0d6efd",
                    border: "none",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    letterSpacing: "0.02em",
                  }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Accediendo…
                    </>
                  ) : (
                    "Acceder"
                  )}
                </Button>
              </Form>

              <p className="text-center mt-4 mb-0" style={{ color: "#999", fontSize: "12px" }}>
                ¿Problemas para acceder? Contacte con el administrador.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
